import { AIDetectorLoadingService } from './AIDetectorLoadingService';
import { AIDetectorVariation, LoadingConfig, RequestLang } from './types';

const SUPPORTED_LANGUAGES = [
  RequestLang.ENGLISH,
  RequestLang.SPANISH,
  RequestLang.PORTUGUESE,
  RequestLang.GERMAN,
  RequestLang.FRENCH,
  RequestLang.ITALIAN,
  RequestLang.KOREAN,
  RequestLang.TURKISH,
  RequestLang.ARABIC,
  RequestLang.CHINESE,
];

const controlConfig: LoadingConfig[] = [
  {
    condition: (requestLang: RequestLang) =>
      requestLang === RequestLang.ENGLISH,
    timeFunction: (wordsCount: number) =>
      Math.round(0.00107 * wordsCount + 1.82) * 1000,
  },
  {
    condition: () => true,
    timeFunction: (wordsCount: number): number => {
      if (wordsCount < 300) {
        return 4 * 1000;
      }
      if (wordsCount > 25000) {
        return 550 * 1000;
      }
      return Math.round(0.0213 * wordsCount + 1.6 * -1) * 1000;
    },
  },
];

const testConfig: LoadingConfig[] = [
  {
    condition: (requestLang: RequestLang) =>
      SUPPORTED_LANGUAGES.includes(requestLang),
    timeFunction: (wordsCount: number) =>
      Math.round(0.00027 * wordsCount + 1.55) * 1000,
  },
  {
    condition: () => true,
    timeFunction: (wordsCount: number): number => {
      if (wordsCount < 100) {
        return 4 * 1000;
      }
      return Math.round(7.4 * Math.log(wordsCount) - 29.8) * 1000;
    },
  },
];

const AIDetectorLoadingServicesMap: Record<
  AIDetectorVariation,
  AIDetectorLoadingService
> = {
  control: new AIDetectorLoadingService(controlConfig),
  test: new AIDetectorLoadingService(testConfig),
};

export { AIDetectorLoadingServicesMap };
